import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSausage = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M16.6,16.6a26.18,26.18,0,0,1-8.77,5.64A3.6,3.6,0,0,1,3,19.6H3a3.6,3.6,0,0,1,2.18-4,19.07,19.07,0,0,0,6.38-4.05,19.07,19.07,0,0,0,4.05-6.38A3.6,3.6,0,0,1,19.6,3h0a3.6,3.6,0,0,1,2.64,4.87A26.18,26.18,0,0,1,16.6,16.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M3.15,20.22a21,21,0,0,1-2.65.62"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M20.84.5a21,21,0,0,1-.62,2.65"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 14.06,
			y1: 14.06,
			x2: 11.52,
			y2: 11.52
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 17.45,
			y1: 8.98,
			x2: 14.91,
			y2: 8.13
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 8.98,
			y1: 17.45,
			x2: 8.13,
			y2: 14.91
		})
	]
});
const ForwardRef = forwardRef(SvgSausage);
export default ForwardRef;
